import React from 'react'
import { decodeEntities } from '../../lib/stringHelperFunctions'
import styled from 'styled-components'
import Text from '../Text/Text'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import { SCREEN_SIZE } from '../../lib/Media'

const DescriptionList = styled.ul`
  list-style-type: none;
  padding: 0;
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 0 1rem;
    > li:not(:last-child) {
      margin-bottom: ${props => (props.listWithGap ? '1.25rem' : '0rem')};
    }
  }
`

const DescriptionListItem = styled.li`
  color: #333333;
`

const PlainCard = styled.div`
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 0 1rem;
  }
`

const BlockText = styled(Text)`
  display: block;
`

export const HtmlTextAttribute = ({ metadata }) => {
  const decodedValue = decodeEntities(metadata.value).split(/<\s*br\s*\/?>/) // change split logic according to delimeter once it is fixed in API
  if (decodedValue.length !== 1) {
    return (
      <DescriptionList listWithGap={metadata.key === 'description'}>
        {decodedValue.map((element, index) => {
          const text = element.replace(/<[^>br]*>|<\/[^>br]*>/g, '')
          return text ? (
            <DescriptionListItem key={index}>
              <Text
                size="medium"
                weight="regular"
                color={defaultTheme.ColorBaseMineShaft700}
              >
                {decodeEntities(text)}
              </Text>
            </DescriptionListItem>
          ) : null
        })}
      </DescriptionList>
    )
  }

  return (
    <>
      {decodedValue.map(element => {
        const plainCardValue = decodeEntities(element).replace(
          /<[^>br]*>|<\/[^>br]*>/g,
          ''
        )
        const lineBrokenValues = plainCardValue.split(/<\s*br\s*\/?>/)
        return (
          <PlainCard key={element}>
            {lineBrokenValues.map(
              plainValue =>
                plainValue && (
                  <BlockText
                    size="medium"
                    weight="regular"
                    key={plainValue}
                    color={defaultTheme.ColorBaseMineShaft700}
                  >
                    {plainValue}
                  </BlockText>
                )
            )}
          </PlainCard>
        )
      })}
    </>
  )
}
